import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  templateUrl: './elementsClientNotRunningModal.component.pug',
  styleUrls: ['./elementsClientNotRunningModal.component.scss'],
})
export class ElementsClientNotRunningModalComponent {
  constructor (public modalInstance: NgbActiveModal) { }
}
